// extracted by mini-css-extract-plugin
export default {"Providers":"Providers_Providers__8ul3o","ProvidersList":"Providers_ProvidersList__rJFTU","ProvidersHeader":"Providers_ProvidersHeader__vjxre"};